
import { Video } from '@/store/videoDashboard/types';

/**
 * Sample videos data - URLs otimizadas para HD (1280x720, qualidade 85%)
 */
export const SAMPLE_VIDEOS = [
  {
    id: '1',
    title: 'VSL PREMIUM 0712',
    description: 'Premium sales video for the main campaign',
    thumbnailUrl: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample1.mp4',
    duration: 180,
    viewCount: 17,
    plays: 594,
    isProcessing: true
  },
  {
    id: '2',
    title: 'REPLICAÇÃO SESSCION 2',
    description: 'Session 2 of the replication series',
    thumbnailUrl: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample2.mp4',
    duration: 240,
    viewCount: 9,
    plays: 1248,
    isProcessing: false
  },
  {
    id: '3',
    title: 'otavio.clap',
    description: 'Otavio demonstration video',
    thumbnailUrl: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample3.mp4',
    duration: 120,
    viewCount: 3,
    plays: 87,
    isProcessing: true
  },
  {
    id: '4',
    title: 'Juliano clep 3',
    description: 'Third video in Juliano series',
    thumbnailUrl: 'https://images.unsplash.com/photo-1596443686812-2f45229eebc3?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample4.mp4',
    duration: 300,
    viewCount: 26,
    plays: 2156,
    isProcessing: false
  },
  {
    id: '5',
    title: 'NOVA_VSL_0712',
    description: 'Updated version of the main sales video',
    thumbnailUrl: 'https://images.unsplash.com/photo-1674574124345-02c525664b65?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample5.mp4',
    duration: 210,
    viewCount: 72,
    plays: 456,
    isProcessing: true
  },
  {
    id: '6',
    title: 'Conheça a REPLIC v3',
    description: 'Introduction to REPLIC version 3',
    thumbnailUrl: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1280&q=85&auto=format&fit=crop',
    videoUrl: '/videos/sample6.mp4',
    duration: 150,
    viewCount: 38,
    plays: 0,
    isProcessing: false
  },
];

// Export for use in store - keep the sample data here to avoid circular dependencies
export type { Video };
